export const sideBarTitle = {
  Inquiry : "照会する",
  ApplicationAndNotification : "申請・届出対応",
  ProxyInputSupport : "代行入力対応",
  PremiumPaymentManagement : "掛金届・掛金納付状況管理",
  RetireeStatusManagement : "退職者状況管理",
  PaymentProcessing : "収納・納付請求処理",
  SubsidyManagement : "補助金管理",
  BusinessStatusManagement : "業務状況管理",
  AccountManagement : "アカウント管理",
  Communication : "コミュニケーション",
  Others : "その他"
} as const;

export default sideBarTitle;
